import React, { FC, useMemo } from "react";
import memoize from "utils/memoize";
import { Country, getOrderedCountries } from "utils/formHelpers";
import {
  RHFormConsumerTextFieldProps,
  RHFormConsumerTextField
} from "component-rh-text-field/RHFormConsumerTextField";

export const CountryField: FC<
  RHFormConsumerTextFieldProps & {
    countryList?: Country[];
    disabledFirstOption?: boolean;
  }
> = ({
  countryList: countryListProp,
  disabledFirstOption = true,
  ...props
}) => {
  // Use default country list if no prop provided
  const countryList = useMemo<Country[]>(() => {
    return countryListProp || getOrderedCountries(["US", "CA"]);
  }, [countryListProp]);

  return (
    <RHFormConsumerTextField
      fullWidth
      select
      defaultValue="US"
      autoComplete="country"
      label={props.label || "Country"}
      name={"country"}
      {...props}
    >
      <option disabled={disabledFirstOption}></option>
      {countryList.map(({ code, name }) => (
        <option key={`country-${code}-${Math.random()}`} value={code}>
          {name}
        </option>
      ))}
    </RHFormConsumerTextField>
  );
};

export default memoize(CountryField);
